// extracted by mini-css-extract-plugin
export var subtitle = "PersonalizedSolutionBlock-module--subtitle--4mSZ7";
export var title = "PersonalizedSolutionBlock-module--title--UIxMZ";
export var contentRow = "PersonalizedSolutionBlock-module--content-row--3UwkS";
export var ctaButton = "PersonalizedSolutionBlock-module--cta-button--1qGM0";
export var content = "PersonalizedSolutionBlock-module--content--HVblX";
export var solutionsContainer = "PersonalizedSolutionBlock-module--solutions-container--38AdB";
export var solutionItem = "PersonalizedSolutionBlock-module--solution-item--3JlzZ";
export var mystrengthContainer = "PersonalizedSolutionBlock-module--mystrength-container--nfOCN";